module.exports = __webpack_public_path__ + "media/3.mp4";